<template>
  <v-container fluid class="login-background fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="3" class="d-flex justify-center">
        <v-form
          ref="form"
          v-model="valid"
          :lazy-validation="lazy"
          style="flex-basis: 100%"
        >
          <v-card class="login-card pa-6 rounded-xl" elevation="16" dark>
            <div class="text-center mb-6">
              <h2 class="font-weight-bold">Tokia Play</h2>
              <div class="subtitle-2 mt-1">Inicio de sesión</div>
            </div>

            <v-text-field
              v-model="usuario"
              prepend-inner-icon="mdi-account"
              :rules="nameRules"
              label="Usuario"
              outlined
              dense
              required
              @keypress.enter="signin"
            />

            <v-text-field
              v-model="pass"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              prepend-inner-icon="mdi-lock"
              :rules="passRules"
              label="Contraseña"
              :type="showPassword ? 'text' : 'password'"
              outlined
              dense
              required
              @keypress.enter="signin"
              @click:append="showPassword = !showPassword"
            />

            <v-btn
              block
              large
              color="#1976d2"
              class="mt-4"
              :disabled="!valid || loading"
              :loading="loading"
              @click="signin"
            >
              Acceder
            </v-btn>

            <div class="text-center">
              <v-btn
                text
                small
                color="#1976d2"
                class="mt-4"
                @click="recuperarPass"
              >
                <v-icon left small>mdi-lock</v-icon>
                ¿Olvidaste tu contraseña?
              </v-btn>
            </div>

            <RecuperoPass
              :visible="showRecuperoPass"
              @close="showRecuperoPass = false"
            />
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from "@/axios-auth.ts";
import RecuperoPass from "@/components/Login/RecuperoPass.vue";
import router from "@/router/index.ts";
export default {
  name: "Login",

  data: () => ({
    valid: false,
    lazy: false,
    showPassword: false,
    loading: false,
    showRecuperoPass: false,
    usuario: "",
    nameRules: [(v) => !!v || "El usuario es un dato requerido"],
    pass: "",
    passRules: [(v) => !!v || "La contraseña es un dato requerido"],
  }),

  methods: {
    recuperarPass() {
      this.showRecuperoPass = true;
    },
    scrollToTop() {},
    signin() {
      this.iniciarSesion();
    },
    iniciarSesion() {
      const formData = {
        usuario: this.usuario,
        pass: this.pass,
      };
      this.loading = true;
      let self = this;
      axios
        .get("/Login?", {
          params: {
            usuario: formData.usuario,
            pass: formData.pass,
          },
        })
        .then(function (response) {
          if (response.data == "Usuario Inexistente") {
            self.showAlert({
              icon: "error",
              title: "Usuario o Contraseña inválidos",
              vm: self,
            });
            self.loading = false;
          } else {
            if (response.data == "Usuario Inactivo") {
              self.showAlert({
                icon: "error",
                title: "Cuenta Inactiva",
                vm: self,
              });
              self.loading = false;
            } else {
              self.$store.commit("saveUserData", {
                token: response.data.token,
                usuario: response.data.usuario,
                profesionales: response.data.profesionalesAsociados,
                canchas: response.data.canchas,
                roles: response.data.roles,
                tabsHc: response.data.tabsHc,
                institucion: response.data.institucion,
                obrasSociales: response.data.obrasSociales,
                horasBloqueoHC: response.data.horasBloqueoHC,
                turnosAlHistoricoFecha: response.data.turnosAlHistoricoFecha,
                usaRecetaElectronica: response.data.usaRecetaElectronica,
                userId: response.data.userId,
              });

              localStorage.setItem("token", response.data.token);
              localStorage.setItem("usuario", response.data.usuario);
              self.showAlert({
                icon: "success",
                title: "Ingreso Exitoso",
                vm: self,
              });
              self.loading = false;
              router.push({ path: "/Home" });
            }
          }
        })
        .catch(function (error) {
          console.log("error", error);
          self.loading = false;
        });
    },
    showAlert(alertInfo) {
      const Toast = alertInfo.vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });

      Toast.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
      });
    },
  },
  created() {
    this.$store.commit("clearAuthData");
  },
  components: {
    RecuperoPass,
  },
};
</script>
<style scoped>
.headline {
  font-size: 1.4rem !important;
}
.login-background {
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #1976d2, #203a43, #2c5364);
}

/* Blob 1 */
.login-background::before {
  content: "";
  position: absolute;
  width: 420px;
  height: 420px;
  background: radial-gradient(circle at center, #00ff9c, transparent 70%);
  top: -120px;
  left: -120px;
  opacity: 0.45;
}

/* Blob 2 */
.login-background::after {
  content: "";
  position: absolute;
  width: 520px;
  height: 520px;
  background: radial-gradient(circle at center, #00c6ff, transparent 70%);
  bottom: -180px;
  right: -180px;
  opacity: 0.35;
}
.login-card {
  backdrop-filter: blur(10px);
  background: rgba(20, 35, 45, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
@keyframes float {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0);
  }
}

.login-background::before,
.login-background::after {
  animation: float 12s ease-in-out infinite;
}
</style>
